import { Button, Col, Row } from 'antd'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { InfoCircleOutlined } from '@ant-design/icons'
import { ResetPasswordEntity } from '../refactory/modules/access-control/infrastructure/reset-password/ResetPasswordModal.types'

interface CardRestoreEntityProps {
  type: ResetPasswordEntity
  dateDeleted: string
  handlerRestoreEntity: () => void
}

const CardRestoreEntity: FC<CardRestoreEntityProps> = ({ type, dateDeleted, handlerRestoreEntity }) => {
  const { t } = useTranslation()
  const entity = useMemo(() => (type === ResetPasswordEntity.USER ? t('user') : t('resource')), [type, t])

  return (
    <Row className='div-banner-restore-resource'>
      <Col span={2} className='div-icon-banner-restore-resource'>
        <InfoCircleOutlined className='icon-banner-restore-resource' />
      </Col>
      <Col span={16}>
        <label className='label-title-banner-restore-resource'>{t('entity_delete', { entity })}</label>
        <label className='label-date-banner-restore-resource'>
          {t('resources.capacity.actionDate')} {dateDeleted}
        </label>
      </Col>
      <Col span={6} className='div-button-banner-restore-resource'>
        <Button onClick={handlerRestoreEntity} type='primary'>
          {t('resources.capacity.restoreOkay')}
        </Button>
      </Col>
    </Row>
  )
}

export default CardRestoreEntity
